<template>
  <span class="container">
    <span class="request">
      <i
        :class="'fas el-icon-fa-sign-' + (record.parent_id ? 'out' : 'in') + '-alt ' + (record.parent_id ? 'icon-outbound' : 'icon-inbound')"
      />
      <HttpStatusCode :code="record.status"/>
      <el-tag size="mini">{{ record.method }}</el-tag>
      <span class="domain">{{ url.protocol + '//' + url.host }}</span>
      <span class="path">{{ url.pathname }}</span>
      <span class="query">{{ (url.search || "") + (url.hash || "") }}</span>
    </span>
    <slot name="middle-content" />
    <span class="datetime">
      <span class="from-now">{{ record.datetime | moment("from") }}</span>
      <span class="date">{{ record.datetime | moment('L') }}</span>
      <span class="time">{{ record.datetime | moment('LTS') }}</span>
    </span>
  </span>
</template>

<script>
const url = require("url");
import HttpStatusCode from "@/components/HttpStatusCode.vue";
  
export default {
  components: {
    HttpStatusCode
  },
  props: ["record"],
  computed: {
    url() {
      return url.parse(this.record.uri, true)
    }
  }
};
</script>

<style scoped lang="sass">

.container
  @include flex($h: space-between, $v: center)
  width: 100%
  color: $--color-text-regular

.el-tag
  margin-right: 5px

.request, .datetime
  flex-shrink: 0 

  i
    margin-right: 5px

  .icon-inbound
    color: $color-primary-light

  .icon-outbound
    color: $color-secondary-light

.domain, .query
  color: $color-secondary-light
  font-family: "Recursive" !important
  font-size: 0.8em
  font-style: italic

.path
  color: $color-secondary
  font-family: "Recursive" !important
  font-weight: bold

.datetime
  span
    margin-right: 5px

.from-now
  font-size: 0.7em
  color: $--color-text-regular

.date
  font-size: 0.85em
  color: $color-secondary

.time
  font-weight: bold
  color: $color-secondary

</style>